import { NgModule } from '@angular/core';
import { TranslateModuleFactory } from './translate/translate.module';
import { EquisModalDialogModule } from '@tn-equis/core/components/modal-dialog';

@NgModule({
  declarations: [],
  imports: [TranslateModuleFactory, EquisModalDialogModule],
  providers: [],
  bootstrap: [],
})
export class ServicesModule {}
